import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebEnvironmentService } from '@dg/shared-services';
import { environment } from 'src/environments/environment';

@Injectable()
export class NgDocApiListInterceptor implements HttpInterceptor {
  constructor(private environmentService: WebEnvironmentService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let reqUrl = request.url;
    //fetch the ng-doc assets from CDN while using production build
    if (environment.isProduction && reqUrl.includes('assets/ng-doc')) {
      reqUrl = reqUrl.replace('assets', '/content');
      reqUrl = this.environmentService.getBlobUrl(reqUrl);
      const modifiedRequest = request.clone({ url: reqUrl });
      return next.handle(modifiedRequest);
    }
    return next.handle(request);
  }
}
